import PropTypes from 'prop-types';

import { Fela } from '../modules/fela';
import { Redux } from '../modules/redux';
import { Router } from '../modules/router';
import { Translations } from '../modules/translations';

import Enhancers from '../containers/Enhancers';

const Core = ({ children, fela, redux }) => (
    <Redux {...redux}>
        <Fela {...fela}>
            <Router>
                <Translations>
                    <Enhancers>{children}</Enhancers>
                </Translations>
            </Router>
        </Fela>
    </Redux>
);

Core.propTypes = {
    children: PropTypes.func.isRequired,
    // eslint-disable-next-line
    fela: PropTypes.object,
    redux: PropTypes.shape({
        reducers: PropTypes.object,
        saga: PropTypes.func,
        middlewares: PropTypes.array,
    }).isRequired,
};

Core.defaultProps = {
    fela: {},
    redux: {},
};

export default Core;
